'use strict';

var $ 			= require('jquery');
var config 		= require('../utils/config.js');
var logger 		= require('../utils/logger.js');

function callApi(requestUrl, successCallback, errorCallback, completeCallback, data) {
	return $.ajax({
		url: config.apiUrl + requestUrl,
		dataType: 'json',
		type: 'POST',
		data: data,
		complete: function (xhr, status) {
			if ($.isFunction(completeCallback)) {
				logger.info('API call complete');
				completeCallback(xhr, status);
			}
		},
		success: function (data, status, xhr) {
			if ($.isFunction(successCallback)) {
				logger.info('API call successful');
				successCallback(data, status, xhr);
			}
		},
		error: function (xhr, status, err) {
			console.log(err);
			if ($.isFunction(errorCallback)) {
				logger.error(
					'API call failed',
					{
						message: 'API error',
						status: status,
						error: err
					}
				);
				errorCallback(status, err, xhr);
			}
		}
	});
}

module.exports = {
	getEquipmentData: function (successCallback, errorCallback, completeCallback, filterRequest) {
		callApi('equipmentreviewsearch', successCallback, errorCallback, completeCallback, filterRequest);
	},
	getCourseData: function (successCallback, errorCallback, completeCallback, filterRequest) {
		callApi('coursereviewsearch', successCallback, errorCallback, completeCallback, filterRequest);
	},
	getNewsData: function (successCallback, errorCallback, completeCallback, filterRequest) {
		callApi('articlenewssearch', successCallback, errorCallback, completeCallback, filterRequest);
	},
	getTipsData: function (successCallback, errorCallback, completeCallback, filterRequest) {
		callApi('articletipssearch', successCallback, errorCallback, completeCallback, filterRequest);
	}
};